import React, { Component } from 'react';
import './_styles.scss';

export default class ButtonTelmex extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { icon, onClick } = this.props;

    return (
      <button
        className="landing-telmex__button-telmex focusable"
        onClick={() => onClick && onClick()}
      >
        {icon && <img src={icon} alt="Telmex" />}
      </button>
    );
  }
}


// WEBPACK FOOTER //
// ./src/authentication/components/LandingTelmex/ButtonTelmex/index.jsx